import { useState, useEffect } from 'react';

/**
 * Custom hook for managing test mode state
 * This hook manages the test mode state globally across the mobile app
 */
const useTestMode = () => {
  const [isTestModeEnabled, setIsTestModeEnabled] = useState(() => {
    // Load initial state from localStorage
    const saved = localStorage.getItem('mobile_test_mode_enabled');
    return saved === 'true';
  });

  // Listen for storage changes from other tabs and custom events from same tab
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'mobile_test_mode_enabled') {
        setIsTestModeEnabled(e.newValue === 'true');
      }
    };

    const handleCustomEvent = (e) => {
      setIsTestModeEnabled(e.detail.enabled);
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('testModeChanged', handleCustomEvent);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('testModeChanged', handleCustomEvent);
    };
  }, []);

  // Function to toggle test mode
  const toggleTestMode = () => {
    const newValue = !isTestModeEnabled;
    setIsTestModeEnabled(newValue);
    localStorage.setItem('mobile_test_mode_enabled', String(newValue));
    
    // Dispatch custom event for same-tab components
    window.dispatchEvent(new CustomEvent('testModeChanged', { 
      detail: { enabled: newValue } 
    }));
    
    console.log('[useTestMode] Test mode toggled:', newValue);
  };

  return {
    isTestModeEnabled,
    toggleTestMode
  };
};

export default useTestMode;